var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "blob3",
    xmlnsXlink: "blob3",
    viewBox: "6333 1761 312 374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ablob3{clip-path:url(#bblob33);}.bblob3{fill:#dfb073;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "bblob33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6333,
    y: 1761,
    width: 312,
    height: 374
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ablob33",
    className: "ablob3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bblob3",
    d: "M12836.523,3268.355c182.067-38.683,182.067-151.215,285.658,116.049s-178.929,232.1-238.572,101.983S12836.523,3268.355,12836.523,3268.355Z",
    transform: "translate(-6502.43 -1450.883)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob3);
export default __webpack_public_path__ + "static/media/blob3.a47c30a1e1fbccc3a1bb2245f328d4b4.svg";
export { ForwardRef as ReactComponent };